import { Bounds } from '@ardoq/graph';
import { AqBlocks } from '../types';
import { RenderParameters } from '../visual/types';
import { createItemSet } from '../itemSet';
import {
  AQBLOCKS_DROPSHADOW_FILL,
  AQBLOCKS_DROPSHADOW_OFFSET,
  AQBLOCKS_MARQUEE_STROKE,
} from '../consts';

import { DragHandler } from './types';
import { extendSelected } from './util';

export class MarqueeDragHandler implements DragHandler {
  public get cursor(): string {
    return 'crosshair';
  }

  public constructor(component: AqBlocks) {
    this.component = component;

    /* TODO STUB IMPLEMENTATIONS

    if (true) {
      //  marquee select 
      // clear component selection
    }

    if (false) {
      // marquee extended select 
      // remember component selection
    }

    */
  }
  private readonly component: AqBlocks;
  //private readonly _selected: Set<BlocksNode | BlocksReference> | undefined;
  private readonly isExtended = false;

  private get bounds(): Bounds {
    const { pointerDown, pointer } = this.component;

    return [
      Math.min(pointerDown[0], pointer[0]),
      Math.min(pointerDown[1], pointer[1]),
      Math.max(pointerDown[0], pointer[0]),
      Math.max(pointerDown[1], pointer[1]),
    ];
  }

  public drag() {
    this.component.autoPan();
    this.component.pendRender();
  }

  public render(params: RenderParameters) {
    const bounds = this.bounds;

    const rc = [
      ...params.projection.projectPoint([bounds[0], bounds[1]]),
      ...params.projection.projectPoint([bounds[2], bounds[3]]),
    ];

    /* outside drop shadow */
    params.ctx.fillStyle = AQBLOCKS_DROPSHADOW_FILL;
    params.ctx.fillRect(
      rc[2],
      rc[1] + AQBLOCKS_DROPSHADOW_OFFSET,
      AQBLOCKS_DROPSHADOW_OFFSET,
      rc[3] - rc[1]
    );
    params.ctx.fillRect(
      rc[0] + AQBLOCKS_DROPSHADOW_OFFSET,
      rc[3],
      rc[2] - rc[0] - AQBLOCKS_DROPSHADOW_OFFSET,
      AQBLOCKS_DROPSHADOW_OFFSET
    );

    /* rectangle outline */

    params.ctx.strokeStyle = AQBLOCKS_MARQUEE_STROKE;
    params.ctx.lineWidth = 1;

    params.ctx.strokeRect(rc[0], rc[1], rc[2] - rc[0], rc[3] - rc[1]);
  }

  public done() {
    const { component, isExtended } = this;
    const items = createItemSet(0);

    // get the items within the marquee rect and add them to the selection or something

    if (isExtended) {
      /* extended */
      component.selected = extendSelected(component, items);
    } else {
      /* normal */
      component.selected = items;
    }

    this.component.autoPan.cancel();
    this.component.pendRender();
  }

  public cancel() {
    this.component.autoPan.cancel();
  }
}
